'use client';
import { css, styled } from '@mui/material/styles';
import { excludeComponentProps } from '../utils/excludeComponentProps';
export const SelectListItem = styled('button', excludeComponentProps('checked', 'hasDivider', 'isCondensed'))(({ theme, ...props }) => css `
    border: unset;
    outline: unset;
    background: unset;

    cursor: pointer;
    display: flex;
    align-items: center;
    gap: ${theme.tokens.FuelSpacing2};
    width: 100%;
    padding: 0 ${theme.tokens.FuelSpacing4};
    height: ${theme.tokens.FuelSpacing10};
    color: ${theme.tokens.FuelColorTextPrimary};
    font-family: ${theme.tokens.FuelFontFamilyBase};
    font-size: ${theme.tokens.FuelFontSizeSm};
    text-align: left;

    &:disabled {
        opacity: .4;
        cursor: not-allowed;
    }

    &:not(:disabled) {
        &:hover, &:focus-visible {
            background-color: ${theme.tokens.FuelColorGray50};
        }

        &:hover .MuiSvgIcon-root { // TODO: should be mui agnostic
            color: ${theme.tokens.FuelColorBrandPrimary};
        }

        &:active {
            background-color: ${theme.tokens.FuelColorBackgroundActionDefaultPressed};
        }

        &:focus-visible {
            box-shadow: inset 0px 0px 0px 2px ${theme.tokens.FuelColorBlack};
        }

        ${props.checked && css `
            background-color: ${theme.tokens.FuelColorGreen50};

            &:hover, &:focus-visible {
                background-color: ${theme.tokens.FuelColorGreen100};
            }

            &:active {
                background-color: ${theme.tokens.FuelColorGreen200};
            }
        `}
    }

    ${props.hasDivider && css `
        &:not(:last-of-type) {
            border-bottom: 0.50px ${theme.tokens.FuelColorBorderBase} solid;
        }
    `}

    ${props.isCondensed && css `
        height: auto;
        padding-inline: 0;
        background-color: unset;

        &:not(:disabled) {
            &:hover, &:active, &:focus-visible {
                background-color: unset;
            }

            &:focus-visible {
                box-shadow: unset;
                outline: 2px solid ${theme.tokens.FuelColorBlack};
                outline-offset: 1px;
            }
        }
    `}
`);
